"use strict";
var Observable_1 = require('../../Observable');
var timeout_1 = require('../../operator/timeout');
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/timeout.js